// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__iBZh-","progress":"ProgressBar_progress__y1h-9","expired":"ProgressBar_expired__PMHZ9","remaining":"ProgressBar_remaining__yThlk"};